//nhanSuCongTrinhService.js
import api from "@/api";

export default {
  // Lấy danh sách nhân sự của dự án
  getByCongTrinh(congTrinhId) {
    return api.get(`/api/cong-trinh/${congTrinhId}/nhan-su`);
  },

  // Thêm nhân sự (Chính thức hoặc Thời vụ)
  add(congTrinhId, data) {
    return api.post(`/api/cong-trinh/${congTrinhId}/nhan-su`, data);
  },

  // Cập nhật (Vai trò, Ngày làm)
  update(id, data) {
    return api.put(`/api/cong-trinh/nhan-su/${id}`, data);
  },

  // Xóa
  delete(id) {
    return api.delete(`/api/cong-trinh/nhan-su/${id}`);
  },

  // --- API LẤY OPTIONS ĐỂ CHỌN ---
  
  // Lấy list nhân viên công ty (NguoiDung)
  getUserOptions(params = {}) {
    const defaultParams = { 
        limit: 100 
    };
    const finalParams = { ...defaultParams, ...params };
    return api.get("/api/nguoi-dung/options", {  params: finalParams });
  },

  // Lấy list thợ thời vụ (ThoivuLaoDong)
  getThoiVuOptions(params = {}) {
    const defaultParams = { 
        keyword: "", 
        status: 1, 
        page: 0, 
        size: 2000
    };
    const finalParams = { ...defaultParams, ...params };
    return api.get("/api/thoivu/lao-dong", { params: finalParams });
  }
};